module.exports = __webpack_public_path__ + "static/media/31JFA4.3807cbe8.jpg";